import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { ref, watch } from 'vue';
import { auth } from '@/firebase';

import { onMounted } from 'vue';
import { useStore } from 'vuex';

// Firebase

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginFormDialog',
  props: {
    isDialogOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isDialogOpen: boolean;
};

const provider = new GoogleAuthProvider();

// Vuex
const store = useStore();




const showDialog = ref(true);

const login = () => {
  console.log('login');
  signInWithPopup(auth, provider)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access the Google API.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential!.accessToken;
    // The signed-in user info.
    const user = result.user;
    // IdP data available using getAdditionalUserInfo(result)
    store.commit('firebase/signIn', user);
    console.log('login successifully');
    
  }).catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    console.log(errorCode, errorMessage, email, credential);

  });

}

onMounted(() => {
  console.log('onMounted', auth);
});

// props.isDialogOpenの値が変更されたら、showDialogの値も変更する
watch(() => props.isDialogOpen, (value) => {
  showDialog.value = value;
});

watch(() => showDialog, (showDialog) => {
  console.log(showDialog.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    id: "firebaseui-auth-container",
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event)),
    "min-width": "400",
    "max-width": "400",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode("LLM Bots: Sign In")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Please sign in with your Google account. ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "red",
                onClick: login
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sign in with Google")
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})